import { render, staticRenderFns } from "./Question1.vue?vue&type=template&id=c3e453da&scoped=true&"
import script from "./Question1.vue?vue&type=script&lang=js&"
export * from "./Question1.vue?vue&type=script&lang=js&"
import style0 from "./Question1.vue?vue&type=style&index=0&id=c3e453da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e453da",
  null
  
)

export default component.exports